import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { catchError, Subscription, throwError, skip } from 'rxjs';
import { BackToSeasonManagerComponent } from 'src/app/dialogs/season-manager-dialogs/back-to-season-manager/back-to-season-manager.component';
import { CreateEditSeasonComponent } from 'src/app/dialogs/season-manager-dialogs/create-edit-season/create-edit-season.component';
import { DeleteSeasonComponent } from 'src/app/dialogs/season-manager-dialogs/delete-season/delete-season.component';
import { EndSeasonComponent } from 'src/app/dialogs/season-manager-dialogs/end-season/end-season.component';
import { SeasonDetailsModel } from 'src/app/models/season-details-model';
import { SeasonCropModel } from 'src/app/models/season-models/season-crop-model';
import { SeasonFarmsModel } from 'src/app/models/season-models/season-farms-model';
import { SeasonMetaDataCombinedModel } from 'src/app/models/season-models/season-meta-data-combined-model';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SeasonManagerService } from 'src/app/services/season-manager.service';
import { SeasonSharedDataService } from 'src/app/services/season-shared-data.service';
import dayjs from "dayjs";
import { UpdateSeasonComponent } from 'src/app/dialogs/season-manager-dialogs/update-season/update-season.component';
import { SeasonFieldInputComponent } from '../season-field-input/season-field-input.component';
import { TenantService } from 'src/app/services/tenant.service';
import {SeasonAdminComponent} from "../season-admin/season-admin.component";
import { CostService } from 'src/app/services/cost.service';
import { FeatureFlagsService } from 'src/app/unleash-feature-flags/feature-flags.service';
import { SeasonDataTableComponent } from '../season-data-table/season-data-table.component';

@Component({
    selector: 'app-season',
    templateUrl: './season.component.html',
    styleUrls: ['./season.component.css'],
    standalone: false
})
export class SeasonComponent implements OnInit, OnDestroy {

  @ViewChildren(SeasonFieldInputComponent) seasoinFieldInput: QueryList<SeasonFieldInputComponent>;

  formsData: any[] = [];

  seasonFormData: any = null;
  seasonDetails: SeasonDetailsModel;
  private seasonMetaDataDetails: SeasonMetaDataCombinedModel;

  protected readonly dayjs = dayjs;

  placeholder: string = '-';
  dateStringFormatting = 'YYYY-MM-DD';

  private routeSub: Subscription;
  private tenantSub: Subscription;
  seasonId: number = 0;
  fieldId: number = 0;

  isUpdateDataVisible: boolean = false;

  isInAnotherActiveSeason: boolean = false;
  isCallDone: boolean = false;
  isSaveBtnVisible: boolean = true;
  /** Disables SAVE while an open field's cultivar size exceeds its field total. */
  cultivarSizeInvalid: boolean = false;
  farms: SeasonFarmsModel[] = null;
  currentComponent: any = null;
  seasonDataTableFlag: boolean = false;


  collectedData: any[] = [];

  constructor(
    private router: Router,
    public nav: NavBarComponent,
    private seasonManagerService: SeasonManagerService,
    private seasonSharedDataService: SeasonSharedDataService,
    public endSeasonDialog: MatDialog,
    private featureFlagsService: FeatureFlagsService,
    public matDialog: MatDialog,
    private route: ActivatedRoute,
    private tenantService: TenantService,
    private costService: CostService
  ) {
    this.seasonSharedDataService.seasonInputFormData$.subscribe(data => {
      this.seasonFormData = data;
    });

    this.seasonSharedDataService.cultivarSizeInvalid$.subscribe(invalid => {
      this.cultivarSizeInvalid = invalid;
    });

    this.seasonSharedDataService.isSaveBtnVisibleData$.subscribe(data => {
      this.isSaveBtnVisible = data;
    });

  }

  ngOnInit(): void {
    this.seasonDataTableFlag = this.checkFeatureFlag();
    this.routeSub = this.route.params.subscribe(params => {
      this.seasonId = params['id'];
      this.seasonSharedDataService.updateSeasonId(this.seasonId);
    });

    this.populateSeasonTopDetails();
    this.populateSeasonDropdownDetails();
    this.seasonSharedDataService.formData$.subscribe(data => {
    this.formsData = data;
    });

    this.getSeasonFarmAndField();

    // Navigate back to seasons list when tenant changes
    this.tenantSub = this.tenantService.currenttenantId.pipe(
      skip(1)
    ).subscribe(() => {
      this.router.navigate(['/season-manager/seasons']);
    });
  }

  checkFeatureFlag(): boolean {
    return this.featureFlagsService.isEnabled('season_data_table');
  }

  getSeasonFarmAndField() {
    this.seasonManagerService.getSeasonById(this.seasonId).pipe(
        catchError(error => {
          console.error();
          return throwError(() => error);
        })
    ).subscribe((res) => {
      this.farms = res;
    })
  }

  openEndSeasonDialog() {

    const dialogRef = this.matDialog.open(EndSeasonComponent, {
      data: {
        seasonId: this.seasonId,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.option === 'end') {
        this.nav.toggleLoading(false);
        this.ngOnInit();
      }
    });
  }

  openSaveFieldDetailsDialog() {

    const dialogRef = this.matDialog.open(UpdateSeasonComponent, {
      data: {
        seasonId: this.seasonId,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.option == 'save') {
        this.saveSeasonDetails();
      }
    });
  }


  openEditSeasonDialog() {
 
    const dialogRef = this.matDialog.open(CreateEditSeasonComponent, {

      data: {
        seasonId: this.seasonId,
        isEditMode: true,
        seasonInfo: this.seasonDetails,
        farms: this.farms,
        note: this.seasonDetails?.note
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        if(this.currentComponent instanceof SeasonAdminComponent) {
          this.currentComponent.populateSeasonFarmAndFieldDetails();
        } else if(this.currentComponent instanceof SeasonDataTableComponent) {
          this.currentComponent.loadData();
        }
      }
      
      this.populateSeasonTopDetails();
    });
  }

  setCurrentComponent(component: any) {
    this.currentComponent = component;
  }


  openDeleteSeasonDialog() {
    const dialogRef = this.matDialog.open(DeleteSeasonComponent, {
      data: {
        seasonId: this.seasonId,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.option == 'delete') {
        this.router.navigate(['/season-manager/seasons']);
      }
    });

  }


  openBackDialog() {
    const dialogRef = this.matDialog.open(BackToSeasonManagerComponent);

    dialogRef.afterClosed().subscribe(result => {
      if(result?.option === 'back') {
        const from = this.route.snapshot.queryParams['from'];
        this.router.navigateByUrl(from || '/season-manager/seasons');
      }
    });
  }


  openUpdateSeasonDialog() {
    const dialogRef = this.matDialog.open(UpdateSeasonComponent, {

      data: {
        seasonId: this.seasonId,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      setTimeout(() => {
        // this.populateSeasonsList();
      }, 1400)

    });

  }


  populateSeasonTopDetails() {
    this.nav.toggleLoading(true);

    this.seasonManagerService.getSeasonFarmsById(this.seasonId).pipe(
      catchError(error => {
        console.error();
        return throwError(() => error);
      })
    ).subscribe((response) => {
      this.seasonDetails = response;
      setTimeout(() => {
        this.nav.toggleLoading(false);
      }, 1400)

    });

  }

  populateSeasonDropdownDetails() {
    this.nav.toggleLoading(true);

    this.seasonManagerService.getSeasonMetaData().pipe(
      catchError(error => {
        console.error();
        return throwError(() => error);
      })
    ).subscribe((response) => {
      this.seasonMetaDataDetails = response;

      if (this.seasonMetaDataDetails == null) {
        return;
      }

      this.seasonSharedDataService.updateCombinedData(this.seasonMetaDataDetails);

      setTimeout(() => {
        this.nav.toggleLoading(false);
      }, 1400)

    });

  }


  saveSeasonDetails() {
    this.nav.toggleLoading(true);
    let count = 0;
    const totalOperations = this.formsData.length;

    // Save costs for all field inputs
    this.seasonSharedDataService.triggerSaveCosts();
    
    for(let data of this.formsData) {
      const fieldTypeId = data?.fieldTypeId ?? data?.fieldType;
      const seasonDetails = {...data};
      delete seasonDetails.fieldId;
      delete seasonDetails.id;
      delete seasonDetails.grainFeed;
      delete seasonDetails.vegetables;
      delete seasonDetails.vineyard;
      delete seasonDetails.fruit;
      delete seasonDetails._costData;

      if (data?.id) {
        this.seasonManagerService.updateSeasonFieldBaseDetails(data.id, seasonDetails).subscribe((response) => {
          if(!fieldTypeId) {
            count++;
            if(totalOperations === count) {
              this.refreshDataAfterSave();
            }
          }
        }, error => {
          count++;
          if(totalOperations === count) {
            this.refreshDataAfterSave();
          }
        });

        if (fieldTypeId) {
          const hasExtraDetail = (fieldTypeId === 1 && data.grainFeed) || (fieldTypeId === 2 && data.vegetables) || (fieldTypeId === 3 && data.vineyard) || (fieldTypeId === 4 && data.fruit);
          if (!hasExtraDetail) {
            count++;
            if(totalOperations === count) {
              this.refreshDataAfterSave();
            }
          }

          if (fieldTypeId === 1 && data.grainFeed) {
            this.seasonManagerService.postSeasonDetailsGrainFeed(data.id, data.grainFeed).subscribe(response => {
              count++;
              if(totalOperations === count) {
                this.refreshDataAfterSave();
              }
            }, error => {
              count++;
              if(totalOperations === count) {
                this.refreshDataAfterSave();
              }
            });
          }

          if (fieldTypeId === 2 && data.vegetables) {
            this.seasonManagerService.postSeasonDetailsVegetables(data.id, data.vegetables).subscribe(response => {
              count++;
              if(totalOperations === count) {
                this.refreshDataAfterSave();
              }
            }, error => {
              count++;
              if(totalOperations === count) {
                this.refreshDataAfterSave();
              }
            });
          }

          if (fieldTypeId === 3 && data.vineyard) {
            this.seasonManagerService.postSeasonDetailsVineyard(data.id, data.vineyard).subscribe(response => {
              count++;
              if(totalOperations === count) {
                this.refreshDataAfterSave();
              }
            }, error => {
              count++;
              if(totalOperations === count) {
                this.refreshDataAfterSave();
              }
            });
          }

          if (fieldTypeId === 4 && data.fruit) {
            this.seasonManagerService.postSeasonDetailsFruit(data.id, data.fruit).subscribe(response => {
              count++;
              if(totalOperations === count) {
                this.refreshDataAfterSave();
              }
            }, error => {
              count++;
              if(totalOperations === count) {
                this.refreshDataAfterSave();
              }
            });
          }
        }
      }
    }
  }

  refreshDataAfterSave() {
    if(this.currentComponent instanceof SeasonAdminComponent) {
      this.currentComponent.populateSeasonFarmAndFieldDetails();
    }
    this.nav.toggleLoading(false);
  }

  refreshBrowser() {
    // FORCE REFRESH BROWSER
    const from = this.route.snapshot.queryParams['from'];
    this.router.navigateByUrl("/season-manager/seasons", { skipLocationChange: true }).then(() => {
      this.router.navigate([`season/${this.seasonId}/season-admin`], { queryParams: { from } });
    });
  }


  ngOnDestroy(): void {
    this.routeSub.unsubscribe();
    this.tenantSub?.unsubscribe();
  }

}
